// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-container[data-v-16517f53] {\n  flex-grow: 1;\n  min-height: 0;\n}\n.chart-container > div[data-v-16517f53] {\n  position: relative;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
